import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { ModalDesktop as Modal } from '@alfalab/core-components-modal/desktop';

import { Content as Component } from '../content';
import type { TContentProps, IContentDeps } from '../models';
import styles from '../../../modal/desktop/desktop.css';

export const ModalV2ContentDesktop = createWidget<IContentDeps, TContentProps>({
    Modal,
    styles,
})(Component);
